module.exports = __webpack_public_path__ + "static/mob_dev_photo-788f6e56238e8cb29bbd823da6639948.jpg";